import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bullet-icon',
  templateUrl: './bullet-icon.component.html',
  styleUrls: ['./bullet-icon.component.scss']
})
export class BulletIconComponent {

  constructor() { }

  ngOnInit() {
  }

}
